"use client";

import { AuthGuard } from "@/components/AuthGuard";
import { MobileHeader } from "@/components/MobileHeader";
import { Sidebar } from "@/components/Sidebar";
import { cn } from "@/lib/utils";
import { useUIStore } from "@/store/uiStore";
import { usePathname } from "next/navigation";

export function ClientLayout({ children }: { children: React.ReactNode }) {
   const pathname = usePathname();
   const isLoginPage = pathname === "/login";
   const isSidebarCollapsed = useUIStore((state) => state.isSidebarCollapsed);

   // Login page - no sidebar, no auth guard needed
   if (isLoginPage) {
      return <>{children}</>;
   }

   // Protected pages - with sidebar, mobile header and auth guard
   return (
      <AuthGuard>
         <div className="min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
            <Sidebar />
            <div
               className={cn(
                  "min-h-screen flex flex-col transition-all duration-300",
                  // On desktop, offset by sidebar width
                  isSidebarCollapsed ? "lg:ml-20" : "lg:ml-64",
               )}
            >
               <MobileHeader />
               <main className="flex-1 w-full max-w-7xl mx-auto p-3.5 sm:p-5 md:p-6 lg:p-8 overflow-x-hidden">
                  {children}
               </main>
            </div>
         </div>
      </AuthGuard>
   );
}

